<template>
    <div class="personalInfo">
       
        <div class="component-container">

            <ul class="nav nav-tabs" id="myTab" role="tablist" style="padding-bottom:1px;">

                <li class="nav-item col" role="presentation">
                    <button class="nav-link active" id="BusinessInfo-tab" data-bs-toggle="tab" data-bs-target="#BusinessInfo" type="button" role="tab" aria-controls="BusinessInfo" aria-selected="true">My Business Information</button>
                </li>
                <li class="nav-item col" role="presentation" style="display:none;">
                    <button class="nav-link" id="BusinessCategory-tab" data-bs-toggle="tab" data-bs-target="#BusinessCategory" type="button" role="tab" aria-controls="BusinessCategory" aria-selected="false">My Business Categories</button>
                </li>
                <li class="nav-item col" role="presentation">
                    <button class="nav-link" id="BusinessDescription-tab" data-bs-toggle="tab" data-bs-target="#BusinessDescription" type="button" role="tab" aria-controls="BusinessDescription" aria-selected="false">My Business Description</button>
                </li>
                <li class="nav-item col" role="presentation">
                    <button class="nav-link" id="Signature-tab" @click="onSignature"  data-bs-toggle="tab" data-bs-target="#Signature" type="button" role="tab" aria-controls="Signature" aria-selected="false">My Signature</button>
                </li>
                <li class="nav-item col" role="presentation">
                    <button class="nav-link" id="AlternateInfo-tab" data-bs-toggle="tab" data-bs-target="#AlternateInfo" type="button" role="tab" aria-controls="AlternateInfo" aria-selected="false">My Contact Info</button>
                </li>
            </ul>

            <div class="tab-content clearfix">
                <div class="tab-pane fade show active" id="BusinessInfo" role="tabpanel" aria-labelledby="BusinessInfo-tab">

                    <div class="box col-12 row">
                        <div class="col-12">
                            <label class="form-label">Business Name <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Name" placeholder="Business Name">
                        </div>
                        <div class="col-8">
                            <label class="form-label">Address <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Address" placeholder="Address">
                        </div>
                        <div class="col-4">
                            <label class="form-label">Unit</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Unit" placeholder="Unit">
                        </div>

                        <div class="col-8">
                            <label class="form-label">City <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.City" placeholder="City">
                        </div>
                        <div class="col-4">
                            <label class="form-label">Province <span class="mandatory">*</span></label>
                            <select class="form-control" v-model="PersonalInfo.Business.Province">
                                <option value="">Please Select</option>
                                <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                            </select>
                        </div>

                        <div class="col-8">
                            <label class="form-label">Postal Code <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.PostalCode" placeholder="Postal Code">
                        </div>
                        <div class="col-4">
                            <label class="form-label">Fax</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Fax" placeholder="Fax">
                        </div>

                        <div class="col-8 col-sm-6">
                            <label class="form-label">Business Phone No. <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Phone" placeholder="Business Phone No.">
                        </div>
                        
                        <div class="col-4 col-sm-4 offset-sm-2">
                            <label class="form-label">Ext</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.PhoneExtension" placeholder="Ext">
                        </div>

                        <div class="col-12 col-sm-6">
                            <label class="form-label">Business Email <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.Email" placeholder="Business Email">
                        </div>
                        <div class="col-0 col-sm-2"></div>
                        <div class="col-6 col-sm-6" style="display:none;">
                            <label class="form-label">Contact First Name <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.FirstName" placeholder="First Name">
                        </div>
                        <div class="col-6 col-sm-6" style="display:none;">
                            <label class="form-label">Contact Last Name <span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.LastName" placeholder="Last Name">
                        </div>
                        <div class="col-12">
                            <div style="color:red; font-size:12px; margin-left:10px; font-weight:bold; margin-top:16px; margin-bottom:16px;">* Mandatory information</div>
                        </div>
                        <div class="col-12" style="text-align:right;">
                           
                            <div class="btn btn-positive" @click="save">Save</div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="BusinessCategory" role="tabpanel" aria-labelledby="BusinessCategory-tab">

                    <div class="box col-12 row">

                        <div class="col-12">
                            <p class="form-label sub-title">Please select all the categories that define your business</p>
                        </div>
                        <div class="col-12">
                            <div class="form-check form-check-inline col-6 col-sm-3" v-for="item in Categories" :key="item.Id">
                                <input type="checkbox" :id="'Categories_'+item.Id" v-model="PersonalInfo.Business.Categories" :value="item.Name" class="form-check-input" />
                                <label class="form-check-label" :for="'Categories_'+item.Id">{{item.Name}}</label>
                            </div>

                        </div>
                        <div class="col-12" style="text-align:right;">
                            <div class="btn btn-positive" @click="save">Save</div>
                        </div>
                    </div>
                  
                </div>

                <div class="tab-pane fade" id="BusinessDescription" role="tabpanel" aria-labelledby="BusinessDescription-tab">
                    <div class="box col-12 row">
                        <div class="col-12">
                            <p class="form-label sub-title">Please provide a breif description of your business(up to 5000 words).</p>
                        </div>
                        <div class="col-12">
                            <textarea type="text" class="form-control" v-model="PersonalInfo.Business.Comments" placeholder="Description" />
                        </div>

                        <div class="col-12" style="text-align:right;">
                            <div class="btn btn-positive" @click="save">Save</div>

                        </div>
                    </div>
                 
                </div>

                <div class="tab-pane fade" id="AlternateInfo" role="tabpanel" aria-labelledby="AlternateInfo-tab">
                    <div class="box col-12 row">
                        <div class="col-12">
                            <p class="form-label sub-title">Please fill in the fields below to provide your signatory info for your agreements.</p>
                        </div>
                        <div class="col-12">  <label class="form-label">Owner / Manager</label></div>
                        <div class="col-6">

                            <input type="text" class="form-control" v-model="PersonalInfo.Business.AltFirstName" placeholder="First Name">
                        </div>
                        <div class="col-6">

                            <input type="text" class="form-control" v-model="PersonalInfo.Business.AltLastName" placeholder="Last Name">
                        </div>

                        <div class="col-12">
                            <label class="form-label col-3">Phone No </label>
                        </div>
                        <div class="col-6 col-sm-6">
                            <input type="text" class="form-control col-6" v-model="PersonalInfo.Business.AltPhone" placeholder="Phone Number">
                        </div>

                        <div class="col-6">

                            <div class="form-check form-check-inline">
                                <input @change="samePhoneChange" type="checkbox" v-model="PersonalInfo.SamePhone" id="samePhone" class="form-check-input" />
                                <label for="samePhone" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as the business phone number provided on my business information page.</label>
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label col-3">Email </label>
                        </div>
                         
                        <div class="col-6">
                            <input type="text" class="form-control" v-model="PersonalInfo.Business.AltEmail" placeholder="Email">
                        </div>
                        <div class="col-6">

                            <div class="form-check form-check-inline">
                                <input @change="sameEmailChange" type="checkbox" v-model="PersonalInfo.SameEmail" id="sameEmail" class="form-check-input" />
                                <label for="sameEmail" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as the business email address provided on my business information page.</label>
                            </div>
                        </div>
                         
                        <div class="col-12" style="text-align:right;">
                            <div class="btn btn-positive" @click="save">Save</div>
                        </div>
                    </div>
                    </div>

                <div class="tab-pane fade" id="Signature" role="tabpanel" aria-labelledby="Signature-tab">
                    <div class="box col-12 row">
                        <div class="width-100p">
                            <h6 style="text-align:center; font-weight:bold; margin:16px 0px;">Your Signature to use on your agreement</h6>

                            <!-- Drag and Drop Area -->
                            <div @drop.prevent="handleFileDrop" @dragover.prevent
                                 class="drag-drop-area"
                                 :style="{ border: previewImage ? 'none' : '2px dashed #aaa', padding: previewImage ? '0' : '20px', textAlign: previewImage ? 'center' : 'center', cursor: 'pointer'}"
                                 @click="$refs.signatureFile.click()"
                                 >
                                <p v-if="!previewImage" style="margin-bottom: 0;">Drag and drop your signature image here, or click to browse</p>

                                <div v-if="previewImage" class="image-container">
                                    <img :src="previewImage" alt="Preview" class="preview-image" />
                                    <div  class="cancel-icon" @click.stop="clearPreview">
                                        <svg class="bi bi-x" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
                                            <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
                                        </svg>
                                    </div>
                                </div>

                            </div>

                            <!-- Hidden File Input (fallback for manual selection) -->
                            <input ref="signatureFile" type="file" accept=".png,.jpg,.gif" @change="handleFileChange" style="display: none;" />
                            <br />

                       
                            <div class="btn btn-positive" @click="onSignatureSave">Save</div>


                            <div v-if="PersonalInfo.Business.Signature != '' && PersonalInfo.Business.Signature != null">

                                <div class="SingnaturePreview">
                                    <div style="font-weight:bold; padding:8px;">Uploaded files</div>
                                    <img :src="'https://cs.cellflare.com/Cloud/' + PersonalInfo.Business.Signature + '?text=No Signature&size=350x150'" />
                                </div>
                            </div>


                            <h6 class="m-t-20" style="font-weight:800;">Signature Pad</h6>
                            <Signature ref="signature" okButton="Save" @cancel-event="onSignatureCancel" @agree-event="onSignatureSave"></Signature>
                        </div>
                    </div>
                </div>
            </div>
             

        </div>
       
       
    </div>
</template>

<script>
    import Signature from '../components/SignatureComponent.vue';
    export default {
        components: {
            Signature
        },
        data() {
            return {
                PersonalInfo: {
                    Business: { Categories:[] },
                },
                title: "Business information", 
                previewImage : null

            }
        },
        mounted() {
            this.$emit('ready');
          
            var idx = this.$route.params.tabIdx;
            var tabs = window.$("#myTab .nav-link");
            
            if (idx >= 0 && idx < tabs.length) {
                tabs[idx].click();
            } else {
                tabs[0].click();
            }


            
        },
        methods: {
          
            titleUpdate(name) {
                this.title = name;
            },
            dataUpdate(obj) {
                //console.log(`dataUpdate ====> `, JSON.stringify(obj));
                this.PersonalInfo = obj;
            },
            sameEmailChange() {
                if (this.PersonalInfo.SameEmail) {
                    this.PersonalInfo.Business.AltEmail = this.PersonalInfo.Business.Email;
                }
            },
            samePhoneChange() {
                if (this.PersonalInfo.SamePhone) {
                    this.PersonalInfo.Business.AltPhone = this.PersonalInfo.Business.Phone;
                }
            },
            save() {
                this.$emit('saveProfile', this.PersonalInfo);
            },

            //signature tabs

            clearPreview() {
                this.previewImage = null;
                
            },
            isValidImage (file)   {
                const validTypes = ['image/png', 'image/jpeg', 'image/gif'];
                return validTypes.includes(file.type);
            },

            handleFileDrop(event) {
                const file = event.dataTransfer.files[0];
                console.log("handleFileDrop", file);

                if (file && this.isValidImage(file)) {
                    this.previewImage = URL.createObjectURL(file);
                    //signatureFile.value = file;
                } 
                /*
                if (files.length) {
                    uploadFile(files[0]);
                }
                */
            },

            handleFileChange(event) {
                const file = event.target.files[0];
                if (file && this.isValidImage(file)) {
                    this.previewImage = URL.createObjectURL(file);
                } 

                 
            },

            onSignature() {
                setTimeout(() => {
                    this.$refs.signature.refresh();
                }, 1000);
                
            },
            onSignatureCancel() {
                console.log(`==== onSignatureCancel ====`);
            },
            onSignatureSave(imageFile) {
                //console.log(`==== onSignatureSave ==== is type of ${typeof imageFile}`, imageFile);
                var file = this.$refs.signatureFile.files[0];
                if (file === null || file === undefined) {
                    this.PersonalInfo.Signature = imageFile;
                    console.log(`==== onSignatureSave ==== is type of ${typeof file}`, file);
                } else {
                    this.PersonalInfo.Signature = file;
                }
               
                this.save();
                this.$refs.signatureFile.value = null;
                this.$refs.signature.onPadClear();

                this.clearPreview();
            }
             
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .form-check-inline{margin: 4px 0px;}
    .form-check-label{vertical-align:middle;}
    .form-check-input{vertical-align:middle;}
   
    .tab-pane{background-color:#fdeddc; padding: 24px 36px; height: 100vh;}

    .drag-and-drop-area {
        border: 2px dashed #ccc;
        padding: 20px;
        text-align: center;
        cursor: pointer;
    }
    .image-container{
        max-height: 150px;
        width:fit-content;
        position:relative;
    }
    .preview-image {
        max-width: 100%;
        max-height: 150px;
        border-radius: 10px;
    }

    .upload-prompt {
        padding: 20px;
        color: #aaa;
    }

    .cancel-icon {
        position: absolute;
        padding:0px;
        background-color:red;
        top: 5px;
        right: 5px;
        cursor: pointer;
        width:20px; height: 20px;
        color: white;
        line-height:17px;
        border-radius: 50%;
    }

    @media (max-width: 768px) {
        .tab-pane {
             
            padding: 12px;
            
        }
    }


</style>


